export const DIALOG_STEPS = {
  FILTER_SELECT: 'filterSelect',
  FILTER_SAVE: 'filterSave',
  FILTER_DELETE: 'filterDelete',
  FILTER_RENAME: 'filterRename',
  FILTER_MERGE: 'filterMerge',
} as const;

export type DialogStep = (typeof DIALOG_STEPS)[keyof typeof DIALOG_STEPS];
